<template>
  
  <div class="container">

    <el-config-provider :locale="locale">
      <router-view class="router-view" />
  </el-config-provider>
   


  </div>

</template>

<script>
import autofit from "autofit.js";
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { HmacSHA1, enc } from 'crypto-js'

export default {
  data() {
    return {};
  },
  methods: {
    initAutofit() {
      const options = {
        el: '#app',
        wh: 1920,
        eh: 1080,
        scaleType: 'stretch',
        offsetLeft: 0,
        offsetTop: 0,
        autoCenter: true,
        resize: true,
        callback: () => {
          console.log('Autofit complete');
        }
      };
      autofit.init(options);
    },
    autofitoff_func() {
      autofit.off();
    }
  },
  mounted() {
    this.initAutofit();
    window.addEventListener('resize', () => {
      this.autofitoff_func();
      this.initAutofit();
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.initAutofit);
    this.autofitoff_func();
  },
  components: {
    ElConfigProvider,
  },
  setup() {
    return {
      locale: zhCn,
    }
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

#app {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background: linear-gradient(180deg, rgba(61, 122, 219, 0.7) 0%, rgba(255, 255, 255, 0.7) 100%);
}

.el-config-provider {
  position: relative;
  width: 100%;
  height: 100%;
}

.router-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:root {
  --el-font-size-base: 14px !important;
}

@media screen and (min-width: 1920px) {
  :root {
    --el-font-size-base: 16px !important;
  }
}

@media screen and (max-width: 1366px) {
  :root {
    --el-font-size-base: 12px !important;
  }
}
</style>